import React from 'react';
import styled from 'styled-components';
import MotifProgressBar from '@ey/motif-react-wrapper/ProgressBar';

export default function ProgressLoader({id, className, show, hideLabel = true}) {
    return <StyledMotifProgressLoader id={id} className={className} show={show} hideLabel={hideLabel} />;
}

const StyledMotifProgressLoader = styled(MotifProgressBar)``;
